import { C } from '../theme';
import { Icon } from '../icons';

/**
 * Property-scope chip (groundwork). Single-property today, so it just names
 * the current property — the `▾` caret marks where a future switcher lands.
 * Styled in Clay; icons never emoji.
 */
export function ScopeChip({ name }: { name?: string }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        maxWidth: '100%',
        padding: '5px 10px',
        borderRadius: 999,
        border: `1px solid ${C.line}`,
        background: C.card,
        color: C.ink2,
        fontSize: 12.5,
        fontWeight: 600,
      }}
    >
      <Icon n="grid" size={13} color={C.accent2} />
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {name ?? 'Property'}
      </span>
      <Icon n="chev" size={12} color={C.muted} style={{ transform: 'rotate(90deg)' }} />
    </span>
  );
}
